// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.......................common Styles Start..........................*/

.ViewProfile-pageContainer-KNqpK {
	width: 100%;
	max-width: 1080px;
	margin-left: auto;
	margin-right: auto;
	overflow: hidden;
}

.ViewProfile-containerResponsive-PrurU {
	max-width: 1080px;
	margin: 0 auto;
}

.ViewProfile-space2-Fta7f {
	margin-bottom: 12px;
}

.ViewProfile-space3-XyWoI {
	margin-bottom: 18px;
}

.ViewProfile-space4-tgS9j {
	margin-bottom: 48px;
}

.ViewProfile-spaceTop3-wDYc3 {
	margin-top: 18px;
}

.ViewProfile-spaceTop4-nkbEM {
	margin-top: 24px;
}

.ViewProfile-spaceTop2-JdcUY {
	margin-top: 12px;
}

a {
	text-decoration: none;
	font-size: 14px;
	line-height: 1.43;
}

a:hover,
a:focus,
a:active {
	text-decoration: none;
}

/*.......................common Styles end..........................*/

/*.......................ProfilePhoto  Styles Start..........................*/

.ViewProfile-slideShow-XYr_V {
	position: relative;
	height: auto;
}

.ViewProfile-slideShowImages-op_IK {
	list-style: none;
	margin: 0;
	padding: 0;
}

.ViewProfile-slideShowImages-op_IK {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	background-color: var(--common-gray-bg-color);
}

.ViewProfile-mediaRound-CM6su {
	border-radius: 50%;
	border: 2px solid var(--primary-white-bg);
}

.ViewProfile-imgResponsive-wwtxl {
	width: 100%;
	height: auto;
}

.ViewProfile-panelHeader-DMMzn {
	border-radius: 0;
	width: 100%;
	display: block;
	color: var(--common-text-color);
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
}

.ViewProfile-circleIcon-QsnRH {
	font-size: 24px;
	line-height: 1;
	font-weight: normal;
	font-style: normal;
	color: var(--modalText-color);
	display: block;
}

.ViewProfile-space3-XyWoI {
	margin-bottom: 18px;
}

.ViewProfile-listStyle-CpVux {
	padding-left: 0;
	list-style: none;
	font-size: 14px;
	line-height: 1.43;
	color: var(--common-text-color);
}

/*.......................ProfilePhoto  Styles End..........................*/

/*.......................Profiledescription Styles Start..........................*/

.ViewProfile-profileTitle-q2087 {
	font-size: 24px;
	font-weight: 600;
	margin-top: 0;
	margin-bottom: 12px;
	line-height: 25px;
	color: var(--common-text-color);
}

.ViewProfile-profileInfo-N2SZR {
	font-size: 16px;
	font-weight: normal;
	line-height: 25px;
	margin-bottom: 0;
	color: var(--common-text-color);
}

.ViewProfile-textCenter-R9PFZ {
	text-align: center;
}

.ViewProfile-colMiddle-n3e9W {
	float: none;
	display: table-cell;
	vertical-align: middle;
}

.ViewProfile-showSm-mXYPe {
	display: none;
}

.ViewProfile-avatarWrapper-bepqw {
	z-index: 5;
	position: relative;
	margin-right: 3px;
}

.ViewProfile-pullRight-eVDJZ {
	float: right;
}

.ViewProfile-homeIcon-eI2W8 {
	height: 16px;
	width: 16px;
	vertical-align: text-bottom;
}

.ViewProfile-profileAvatarLink-isGWn {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	width: 68px;
	height: 68px;
	overflow: hidden;
	border-radius: 50%;
	border: 2px solid var(--common-link-color);
	background-color: transparent;
	padding: 3px;
	position: relative;
	z-index: 5;
}

.ViewProfile-profileAvatarLink-isGWn img {
	width: 100%;
	height: 100%;
	-o-object-fit: contain;
	   object-fit: contain;
	background-color: var(--primary-white-bg);
	border-radius: 50%;
}

.ViewProfile-avatarDisplay-o7CZI {
	display: table-cell;
}

.ViewProfile-commentContainer-oFlS4 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
}

.ViewProfile-reviewMuted-mwjNk {
	color: var(--modalText-color);
}

.ViewProfile-horizontalLineThrough-b5HMz {
	position: relative;
	z-index: 1;
	display: block;
	margin: 15px 1px;
	width: 100%;
	color: var(--modalText-color);
	text-align: center;
	font-size: 14px;
}

.ViewProfile-reviewBody-ZeXbk {
	display: table-cell;
	padding-left: 5px;
}

.ViewProfile-avatarDisplay-o7CZI {
	display: table-cell;
}

.ViewProfile-textBold-CKppE {
	font-weight: bold;
}

.ViewProfile-profileName-s1ncG {
	margin: 4px 0;
	max-width: 74px;
	word-wrap: break-word;
	font-size: 12px;
}

.ViewProfile-recommendations-qZ5x7>div:last-child .ViewProfile-lineSeperation-uXoq2 {
	opacity: 0;
	height: 0;
}

.ViewProfile-recommendations-qZ5x7 {
	background: var(--primary-white-bg);
}

.ViewProfile-heading-gCg9o {
	background: transparent;
	-webkit-column-gap: 6px;
	   -moz-column-gap: 6px;
	        column-gap: 6px;
	font-size: 18px;
	font-weight: 600;
	padding-bottom: 10px;
}

.ViewProfile-loadMoreText-hO67Q {
	margin-top: 4px;
	margin-bottom: 0;
}

.ViewProfile-padding5per-Jae8x {
	padding: 0 5%;
}

.ViewProfile-btn-szFGj {
	padding: 7px 21px;
	border-color: var(--primary-border);
	background: var(--primary-white-bg);
	color: var(--common-text-color);
	font-weight: bold;
	font-size: 14px;
	border-radius: 0px;
	cursor: pointer;
}

.ViewProfile-btnPrimary-e5cJh {
	border-color: var(--btn-primary-bg);
	background-color: var(--btn-primary-bg);
	color: var(--white-text);
	height: 48px;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	background: var(--btn-primary-bg);
	border-radius: 6px;
	padding: 12px 19px;
	font-size: 18px;
	font-weight: 500;
	cursor: pointer;
}

.ViewProfile-btnPrimary-e5cJh:hover,
.ViewProfile-btnPrimary-e5cJh:focus,
.ViewProfile-btnPrimary-e5cJh:active,
.ViewProfile-btnPrimary-e5cJh:active:hover,
.ViewProfile-btnPrimary-e5cJh:active:focus,
.ViewProfile-btnPrimary-e5cJh[disabled]:hover,
.ViewProfile-btnPrimary-e5cJh[disabled]:focus {
	border-color: var(--btn-primary-bg) !important;
	background-color: var(--btn-primary-bg) !important;
	color: var(--white-text) !important;
}

.ViewProfile-btnPrimaryBorder-OisCV {
	border-color: var(--btn-primary-bg);
	color: var(--btn-primary-bg);
	background-color: var(--primary-white-bg);
	border-radius: 60px;
}

.ViewProfile-btnPrimaryBorder-OisCV:hover,
.ViewProfile-btnPrimaryBorder-OisCV:focus,
.ViewProfile-btnPrimaryBorder-OisCV:active,
.ViewProfile-btnPrimaryBorder-OisCV:active:hover,
.ViewProfile-btnPrimaryBorder-OisCV:active:focus {
	border-color: var(--btn-primary-bg);
	color: var(--btn-primary-bg);
	background-color: var(--primary-white-bg);
}

.ViewProfile-btnRadius-yKcWB {
	border-radius: 0px;
}

.ViewProfile-linkBtn-cEI2C {
	border-radius: 4px;
	padding: 9px 21px;
}

.ViewProfile-textalign-cWOtq {
	text-align: left;
}

.ViewProfile-imageContent-CbqOr {
	height: 150px;
	width: 150px;
}

.ViewProfile-noBackground-yt8_T {
	background: transparent !important;
}

.ViewProfile-adminImg-BbLL0 {
	position: relative;
	z-index: 5;
}

.ViewProfile-adminImg-BbLL0 img {
	border-radius: 50%;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	-ms-border-radius: 50%;
	-o-border-radius: 50%;
}

.ViewProfile-messageContent-Yqu0X {
	background: var(--primary-white-bg);
	padding: 15px 24px;
	position: relative;
	width: 100%;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	border-top-right-radius: 4px;
}

.ViewProfile-lineCss-UWKBG {
	margin: 18px 0;
	border: 1px solid var(--primary-border);
}

.ViewProfile-subTitle-PtZIQ {
	font-size: 18px;
	font-weight: 600;
	line-height: 25px;
	margin-top: 0;
	margin-bottom: 12px;
}

.ViewProfile-subContent-wrlfF {
	font-size: 16px;
	font-weight: normal;
	line-height: 22px;
	margin-bottom: 0;
	color: var(--common-text-color);
	word-break: break-word;
}

.ViewProfile-collapseBtn-UXaIG,
.ViewProfile-collapseBtn-UXaIG:hover,
.ViewProfile-collapseBtn-UXaIG:focus {
	font-size: 18px;
	color: var(--common-link-color);
	padding: 0;
	margin-top: 14px;
	border-bottom: 1px solid var(--common-link-color);
	text-decoration: unset !important;
}

.ViewProfile-panelBody-QA_iN {
	padding-bottom: 20px;
}

.ViewProfile-noDataImageContainer-dRivn {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	min-height: 468px;
}

.ViewProfile-noDataImageContainer-dRivn img {
	width: 300px;
	height: 300px;
}

@media screen and (max-width: 767px) {
	.ViewProfile-showSm-mXYPe {
		display: block;
	}

	.ViewProfile-hideSm-mkQwS {
		display: none;
	}

	.ViewProfile-profileName-s1ncG {
		width: 100%;
		max-width: 100%;
	}

	.ViewProfile-avatarWrapper-bepqw {
		text-align: center;
		float: none;
	}

	.ViewProfile-smPadding-fqobJ {
		padding: 0px;
	}

	.ViewProfile-centerFlex-_cm89 {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.ViewProfile-textalign-cWOtq {
		text-align: center;
	}

	.ViewProfile-profileTitle-q2087 {
		font-size: 24px;
		margin-top: 0;
		margin-bottom: 15px;
		line-height: 1.1;
		color: var(--common-text-color);
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.ViewProfile-noDataImageContainer-dRivn {
		min-height: 350px;
	}

	.ViewProfile-noDataImageContainer-dRivn img {
		width: 80%;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ViewProfile/ViewProfile.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;CACC,WAAW;CACX,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;CAGC,qBAAqB;AACtB;;AAEA,qEAAqE;;AAErE,8EAA8E;;AAE9E;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,6CAA6C;AAC9C;;AAEA;CACC,kBAAkB;CAClB,yCAAyC;AAC1C;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,+BAA+B;CAC/B,eAAe;CACf,oBAAoB;CACpB,8CAA8C;AAC/C;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,kBAAkB;CAClB,6BAA6B;CAC7B,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,+BAA+B;AAChC;;AAEA,4EAA4E;;AAE5E,mFAAmF;;AAEnF;CACC,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,+BAA+B;AAChC;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,2BAA2B;AAC5B;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,6BAA6B;CAC7B,YAAY;CACZ,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;CACnB,yCAAyC;CACzC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,6BAA6B;CAC7B,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,uBAAuB;CACvB,uBAAe;IAAf,oBAAe;SAAf,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,mCAAmC;CACnC,mCAAmC;CACnC,+BAA+B;CAC/B,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,mCAAmC;CACnC,uCAAuC;CACvC,wBAAwB;CACxB,YAAY;CACZ,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,iCAAiC;CACjC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAGA;;;;;;;CAOC,8CAA8C;CAC9C,kDAAkD;CAClD,mCAAmC;AACpC;;AAEA;CACC,mCAAmC;CACnC,4BAA4B;CAC5B,yCAAyC;CACzC,mBAAmB;AACpB;;AAEA;;;;;CAKC,mCAAmC;CACnC,4BAA4B;CAC5B,yCAAyC;AAC1C;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,YAAY;AACb;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;CACX,8BAA8B;CAC9B,+BAA+B;CAC/B,4BAA4B;AAC7B;;AAEA;CACC,cAAc;CACd,uCAAuC;AACxC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;;;CAGC,eAAe;CACf,+BAA+B;CAC/B,UAAU;CACV,gBAAgB;CAChB,iDAAiD;CACjD,iCAAiC;AAClC;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAIA;CACC;EACC,cAAc;CACf;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,WAAW;EACX,eAAe;CAChB;;CAEA;EACC,kBAAkB;EAClB,WAAW;CACZ;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;CACxB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,UAAU;CACX;AACD","sourcesContent":["/*.......................common Styles Start..........................*/\n\n.pageContainer {\n\twidth: 100%;\n\tmax-width: 1080px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\toverflow: hidden;\n}\n\n.containerResponsive {\n\tmax-width: 1080px;\n\tmargin: 0 auto;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.space4 {\n\tmargin-bottom: 48px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\na {\n\ttext-decoration: none;\n\tfont-size: 14px;\n\tline-height: 1.43;\n}\n\na:hover,\na:focus,\na:active {\n\ttext-decoration: none;\n}\n\n/*.......................common Styles end..........................*/\n\n/*.......................ProfilePhoto  Styles Start..........................*/\n\n.slideShow {\n\tposition: relative;\n\theight: auto;\n}\n\n.slideShowImages {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.slideShowImages {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tbackground-color: var(--common-gray-bg-color);\n}\n\n.mediaRound {\n\tborder-radius: 50%;\n\tborder: 2px solid var(--primary-white-bg);\n}\n\n.imgResponsive {\n\twidth: 100%;\n\theight: auto;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tcolor: var(--common-text-color);\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.circleIcon {\n\tfont-size: 24px;\n\tline-height: 1;\n\tfont-weight: normal;\n\tfont-style: normal;\n\tcolor: var(--modalText-color);\n\tdisplay: block;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.listStyle {\n\tpadding-left: 0;\n\tlist-style: none;\n\tfont-size: 14px;\n\tline-height: 1.43;\n\tcolor: var(--common-text-color);\n}\n\n/*.......................ProfilePhoto  Styles End..........................*/\n\n/*.......................Profiledescription Styles Start..........................*/\n\n.profileTitle {\n\tfont-size: 24px;\n\tfont-weight: 600;\n\tmargin-top: 0;\n\tmargin-bottom: 12px;\n\tline-height: 25px;\n\tcolor: var(--common-text-color);\n}\n\n.profileInfo {\n\tfont-size: 16px;\n\tfont-weight: normal;\n\tline-height: 25px;\n\tmargin-bottom: 0;\n\tcolor: var(--common-text-color);\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.colMiddle {\n\tfloat: none;\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.showSm {\n\tdisplay: none;\n}\n\n.avatarWrapper {\n\tz-index: 5;\n\tposition: relative;\n\tmargin-right: 3px;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.homeIcon {\n\theight: 16px;\n\twidth: 16px;\n\tvertical-align: text-bottom;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\twidth: 68px;\n\theight: 68px;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tborder: 2px solid var(--common-link-color);\n\tbackground-color: transparent;\n\tpadding: 3px;\n\tposition: relative;\n\tz-index: 5;\n}\n\n.profileAvatarLink img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: contain;\n\tbackground-color: var(--primary-white-bg);\n\tborder-radius: 50%;\n}\n\n.avatarDisplay {\n\tdisplay: table-cell;\n}\n\n.commentContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.reviewMuted {\n\tcolor: var(--modalText-color);\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: block;\n\tmargin: 15px 1px;\n\twidth: 100%;\n\tcolor: var(--modalText-color);\n\ttext-align: center;\n\tfont-size: 14px;\n}\n\n.reviewBody {\n\tdisplay: table-cell;\n\tpadding-left: 5px;\n}\n\n.avatarDisplay {\n\tdisplay: table-cell;\n}\n\n.textBold {\n\tfont-weight: bold;\n}\n\n.profileName {\n\tmargin: 4px 0;\n\tmax-width: 74px;\n\tword-wrap: break-word;\n\tfont-size: 12px;\n}\n\n.recommendations>div:last-child .lineSeperation {\n\topacity: 0;\n\theight: 0;\n}\n\n.recommendations {\n\tbackground: var(--primary-white-bg);\n}\n\n.heading {\n\tbackground: transparent;\n\tcolumn-gap: 6px;\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tpadding-bottom: 10px;\n}\n\n.loadMoreText {\n\tmargin-top: 4px;\n\tmargin-bottom: 0;\n}\n\n.padding5per {\n\tpadding: 0 5%;\n}\n\n.btn {\n\tpadding: 7px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: var(--primary-white-bg);\n\tcolor: var(--common-text-color);\n\tfont-weight: bold;\n\tfont-size: 14px;\n\tborder-radius: 0px;\n\tcursor: pointer;\n}\n\n.btnPrimary {\n\tborder-color: var(--btn-primary-bg);\n\tbackground-color: var(--btn-primary-bg);\n\tcolor: var(--white-text);\n\theight: 48px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tbackground: var(--btn-primary-bg);\n\tborder-radius: 6px;\n\tpadding: 12px 19px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tcursor: pointer;\n}\n\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus,\n.btnPrimary[disabled]:hover,\n.btnPrimary[disabled]:focus {\n\tborder-color: var(--btn-primary-bg) !important;\n\tbackground-color: var(--btn-primary-bg) !important;\n\tcolor: var(--white-text) !important;\n}\n\n.btnPrimaryBorder {\n\tborder-color: var(--btn-primary-bg);\n\tcolor: var(--btn-primary-bg);\n\tbackground-color: var(--primary-white-bg);\n\tborder-radius: 60px;\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n\tborder-color: var(--btn-primary-bg);\n\tcolor: var(--btn-primary-bg);\n\tbackground-color: var(--primary-white-bg);\n}\n\n.btnRadius {\n\tborder-radius: 0px;\n}\n\n.linkBtn {\n\tborder-radius: 4px;\n\tpadding: 9px 21px;\n}\n\n.textalign {\n\ttext-align: left;\n}\n\n.imageContent {\n\theight: 150px;\n\twidth: 150px;\n}\n\n.noBackground {\n\tbackground: transparent !important;\n}\n\n.adminImg {\n\tposition: relative;\n\tz-index: 5;\n}\n\n.adminImg img {\n\tborder-radius: 50%;\n\t-webkit-border-radius: 50%;\n\t-moz-border-radius: 50%;\n\t-ms-border-radius: 50%;\n\t-o-border-radius: 50%;\n}\n\n.messageContent {\n\tbackground: var(--primary-white-bg);\n\tpadding: 15px 24px;\n\tposition: relative;\n\twidth: 100%;\n\tborder-bottom-left-radius: 4px;\n\tborder-bottom-right-radius: 4px;\n\tborder-top-right-radius: 4px;\n}\n\n.lineCss {\n\tmargin: 18px 0;\n\tborder: 1px solid var(--primary-border);\n}\n\n.subTitle {\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tline-height: 25px;\n\tmargin-top: 0;\n\tmargin-bottom: 12px;\n}\n\n.subContent {\n\tfont-size: 16px;\n\tfont-weight: normal;\n\tline-height: 22px;\n\tmargin-bottom: 0;\n\tcolor: var(--common-text-color);\n\tword-break: break-word;\n}\n\n.collapseBtn,\n.collapseBtn:hover,\n.collapseBtn:focus {\n\tfont-size: 18px;\n\tcolor: var(--common-link-color);\n\tpadding: 0;\n\tmargin-top: 14px;\n\tborder-bottom: 1px solid var(--common-link-color);\n\ttext-decoration: unset !important;\n}\n\n.panelBody {\n\tpadding-bottom: 20px;\n}\n\n.noDataImageContainer {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: 468px;\n}\n\n.noDataImageContainer img {\n\twidth: 300px;\n\theight: 300px;\n}\n\n\n\n@media screen and (max-width: 767px) {\n\t.showSm {\n\t\tdisplay: block;\n\t}\n\n\t.hideSm {\n\t\tdisplay: none;\n\t}\n\n\t.profileName {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t}\n\n\t.avatarWrapper {\n\t\ttext-align: center;\n\t\tfloat: none;\n\t}\n\n\t.smPadding {\n\t\tpadding: 0px;\n\t}\n\n\t.centerFlex {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t.textalign {\n\t\ttext-align: center;\n\t}\n\n\t.profileTitle {\n\t\tfont-size: 24px;\n\t\tmargin-top: 0;\n\t\tmargin-bottom: 15px;\n\t\tline-height: 1.1;\n\t\tcolor: var(--common-text-color);\n\t\toverflow: hidden;\n\t\twhite-space: nowrap;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t.noDataImageContainer {\n\t\tmin-height: 350px;\n\t}\n\n\t.noDataImageContainer img {\n\t\twidth: 80%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `ViewProfile-pageContainer-KNqpK`,
	"containerResponsive": `ViewProfile-containerResponsive-PrurU`,
	"space2": `ViewProfile-space2-Fta7f`,
	"space3": `ViewProfile-space3-XyWoI`,
	"space4": `ViewProfile-space4-tgS9j`,
	"spaceTop3": `ViewProfile-spaceTop3-wDYc3`,
	"spaceTop4": `ViewProfile-spaceTop4-nkbEM`,
	"spaceTop2": `ViewProfile-spaceTop2-JdcUY`,
	"slideShow": `ViewProfile-slideShow-XYr_V`,
	"slideShowImages": `ViewProfile-slideShowImages-op_IK`,
	"mediaRound": `ViewProfile-mediaRound-CM6su`,
	"imgResponsive": `ViewProfile-imgResponsive-wwtxl`,
	"panelHeader": `ViewProfile-panelHeader-DMMzn`,
	"circleIcon": `ViewProfile-circleIcon-QsnRH`,
	"listStyle": `ViewProfile-listStyle-CpVux`,
	"profileTitle": `ViewProfile-profileTitle-q2087`,
	"profileInfo": `ViewProfile-profileInfo-N2SZR`,
	"textCenter": `ViewProfile-textCenter-R9PFZ`,
	"colMiddle": `ViewProfile-colMiddle-n3e9W`,
	"showSm": `ViewProfile-showSm-mXYPe`,
	"avatarWrapper": `ViewProfile-avatarWrapper-bepqw`,
	"pullRight": `ViewProfile-pullRight-eVDJZ`,
	"homeIcon": `ViewProfile-homeIcon-eI2W8`,
	"profileAvatarLink": `ViewProfile-profileAvatarLink-isGWn`,
	"avatarDisplay": `ViewProfile-avatarDisplay-o7CZI`,
	"commentContainer": `ViewProfile-commentContainer-oFlS4`,
	"reviewMuted": `ViewProfile-reviewMuted-mwjNk`,
	"horizontalLineThrough": `ViewProfile-horizontalLineThrough-b5HMz`,
	"reviewBody": `ViewProfile-reviewBody-ZeXbk`,
	"textBold": `ViewProfile-textBold-CKppE`,
	"profileName": `ViewProfile-profileName-s1ncG`,
	"recommendations": `ViewProfile-recommendations-qZ5x7`,
	"lineSeperation": `ViewProfile-lineSeperation-uXoq2`,
	"heading": `ViewProfile-heading-gCg9o`,
	"loadMoreText": `ViewProfile-loadMoreText-hO67Q`,
	"padding5per": `ViewProfile-padding5per-Jae8x`,
	"btn": `ViewProfile-btn-szFGj`,
	"btnPrimary": `ViewProfile-btnPrimary-e5cJh`,
	"btnPrimaryBorder": `ViewProfile-btnPrimaryBorder-OisCV`,
	"btnRadius": `ViewProfile-btnRadius-yKcWB`,
	"linkBtn": `ViewProfile-linkBtn-cEI2C`,
	"textalign": `ViewProfile-textalign-cWOtq`,
	"imageContent": `ViewProfile-imageContent-CbqOr`,
	"noBackground": `ViewProfile-noBackground-yt8_T`,
	"adminImg": `ViewProfile-adminImg-BbLL0`,
	"messageContent": `ViewProfile-messageContent-Yqu0X`,
	"lineCss": `ViewProfile-lineCss-UWKBG`,
	"subTitle": `ViewProfile-subTitle-PtZIQ`,
	"subContent": `ViewProfile-subContent-wrlfF`,
	"collapseBtn": `ViewProfile-collapseBtn-UXaIG`,
	"panelBody": `ViewProfile-panelBody-QA_iN`,
	"noDataImageContainer": `ViewProfile-noDataImageContainer-dRivn`,
	"hideSm": `ViewProfile-hideSm-mkQwS`,
	"smPadding": `ViewProfile-smPadding-fqobJ`,
	"centerFlex": `ViewProfile-centerFlex-_cm89`
};
module.exports = ___CSS_LOADER_EXPORT___;
